import { Contract } from "../../contract.interface";

export interface SelectSignatureProps {
  showSignatures: boolean;
  setShowSignaturesDialog: (value: boolean) => void;
  contract: Contract;
  refetchContract: () => void;
  openModalConfirmContract: (signatureId: string) => Promise<void>;
  selectedSalesTeamId: number;
  travelDate: Date;
}

export interface GetAccountSignaturesProps {
  accountId: number;
  contactType: string;
}

export interface FormValuesType {
  whatsapp: string;
  email: string;
}

export enum AccountContactType {
  PHONE_NUMBER = "PHONE_NUMBER",
  CELL_NUMBER = "CELL_NUMBER",
  FAX = "FAX",
  EMAIL = "EMAIL",
  SKYPE = "SKYPE",
  WHATSAPP = "WHATSAPP",
  FACEBOOK = "FACEBOOK",
  STANDARD = "STANDARD"
}

export interface AccountContact {
  id: number;
  contactType: AccountContactType;
  contact: string;
}

interface LegalRepresentative {
  id: number;
  email: string;
  whatsapp: string;
}

export interface OverwriteContract {
  accountId: number;
  signatureId?: string;
  salesTeamId?: number;
  accountContact?: AccountContact;
  accountLegalRepresentatives?: LegalRepresentative[];
  travelDate?: Date;
}

export interface SelectedSignatureProps {
  id: string;
  name: AccountContactType;
}

export interface SelectedContact {
  id: string;
  name: string;
}

interface ContactsPhysicalProps {
  id: string;
  objectTypeCode: string;
  contact: string;
  contactType: AccountContactType;
  parentTypeCodeId: number;
}

interface ContactsLegalProps {
  birthDate: string;
  document: string;
  email: string;
  fullName: string;
  id: string;
  parentTypeCodeId: number;
  role: null | string;
  whatsapp: string;
}

export type Contacts = ContactsPhysicalProps[] | ContactsLegalProps[];
